import React from 'react';

import LandingPageCTAButton from 'shared/components/LandingPageCTA/LandingPageCTAButton';

const RegistrationButton = ({
  text = '',
  link = '',
  disabled = false,
  target,
  onClick = () => {},
}) => {
  return (
    <LandingPageCTAButton
      text={text}
      link={link}
      disabled={disabled}
      target={target}
      onClick={onClick}
    />
  );
};

export default RegistrationButton;
